// @ts-nocheck
import {KTSVG} from '../../../../../../_metronic/helpers'
import {BASE_URL, useGetUserReportFileQuery} from '../../../../../../api'
import {useListView} from '../../core/ListViewProvider'
import {UsersListFilter} from './UsersListFilter'
import React, {useEffect, useState} from 'react'
import {URL} from '../../../../../../api'
import {AllUsersData} from '../../table/UsersTable'
import * as XLSX from 'xlsx'
import axios from 'axios'
import useClasses from '../../../../../hooks/useClasses'

const downloadExcel = (data) => {
  const worksheet = XLSX.utils.json_to_sheet(data)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
  //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
  //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
  XLSX.writeFile(workbook, 'DataSheet.xlsx')
}

const UsersListToolbar = ({
  page,
  setPage,
  sDate,
  setSDate,
  setEDate,
  eDate,
  genderFilter,
  setGenderFilter,
  userSearch,
}) => {
  const {setItemIdForUpdate} = useListView()

  const [userData, setUserData] = useState([])

  const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }
  const [loading, setLoading] = useState(false)

  const {downloadClasses} = useClasses()
  const fetchData = async () => {
    try {
      setLoading(true) // Set loading to true while data is being fetched
      const {data, status} = await downloadClasses()
      downloadExcel(data)
    } catch (error) {
      setLoading(false) // Set loading to false on error
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <UsersListFilter
        genderFilter={genderFilter}
        setGenderFilter={setGenderFilter}
        sDate={sDate}
        setSDate={setSDate}
        setEDate={setEDate}
        eDate={eDate}
        page={page}
        setPage={setPage}
      />

      {/* begin::Export */}
      <button
        type='button'
        className='btn btn-light-primary me-3'
        onClick={fetchData}
        disabled={loading}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <a>{loading ? 'Downloading...' : 'Export'}</a>
      </button>
      {/* end::Export */}

      {/* begin::Add user */}
      {/* <button type='button' className='btn btn-primary' onClick={openAddUserModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        Add User
      </button> */}
      {/* end::Add user */}
    </div>
  )
}

export {UsersListToolbar}
